export default __webpack_public_path__ + "static/media/SEL-Show-1.503ddd46.jpg";